import { applyEmptyChartState, seriesHasData } from '@/data/chartEmptyState.js'

export function getChartOptions(totalCpu, _dataArray) {

    var dataArray = Object.assign({cache: [], total: [], used: [], buffer:[] }, _dataArray)
  
    var dataSeries = {
      name: '',
      type: 'line',
      smooth: true,
      showSymbol: false,
      areaStyle: {
        opacity: 0.1
      },
      lineStyle: {
        width: 1
      },
      data: []
    };
  
  
  
    var options = {
      animation: false,
      title: {
        text: ''
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      legend: {
        orient: 'horizontal',
        bottom: '4%'
      },
      grid: {
        top: '3%',
        left: '3%',
        right: '4%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: false,
        feature: {
          restore: {},
        },
      },
      xAxis: {
        type: 'time',
        boundaryGap: false
      },
      yAxis: {
        type: 'value',
        min: 0,
        axisLabel: {
          formatter: function (value) {
            return value + ' %'; // Labeling the yAxis values as MB
          }
        }
      },
      series: []
    }
     // Convert data points from bits to megabytes for each series
    function convertDataToGB(data) {
      return data.map(point => [point[0], point[1]]); // Convert to GB
    }
  
    if (dataArray.cache.length > 0) {
      const arr = Object.assign({}, dataSeries);
      arr.id = 'idle'
      arr.name = 'Idle'
      arr.data = convertDataToGB(dataArray.cache)
      options.series.push(arr);
    }
    if (dataArray.total.length > 0) {
      const arr = Object.assign({}, dataSeries);
      arr.id = 'interrupt'
      arr.name = 'Interrupt'
      arr.data = convertDataToGB(dataArray.total)
      options.series.push(arr);
    }
    if (dataArray.used.length > 0) {
      const arr = Object.assign({}, dataSeries);
      arr.id = 'user'
      arr.name = 'User'
      arr.data = convertDataToGB(dataArray.used);
      options.series.push(arr);
    }
    if (dataArray.buffer.length > 0) {
      const arr = Object.assign({}, dataSeries);
      arr.id = 'system'
      arr.name = 'System'
      arr.data = convertDataToGB(dataArray.buffer);
      options.series.push(arr);
    }
  
    return applyEmptyChartState(options, seriesHasData(options.series));
  }

  